import { createSearchPageSlice } from '../../../Generic/SearchPage/slices/searchPageSlice';
import { SortDirection } from '../../../../utils/constants';

export const filterFields = {
  orderNumber: 'orderNumber',
  statusIDs: 'statusIDs',
  requestor: 'requestor',
  rushOrder: 'rushOrder',
  clientIDs: 'clientIDs',
  reportAddressIDs: 'reportAddressIDs',
  invoiceAddressIDs: 'invoiceAddressIDs',
  companyName: 'companyName',
  ShipCity: 'ShipCity',
  supplyTypes: 'supplyTypes',
  templateNo: 'templateNo',
  dueDateFrom: 'dueDateFrom',
  dueDateTo: 'dueDateTo',
  shipToFacility: 'shipToFacility',
  shipToCompany: 'shipToCompany',
};
const initialFilterState = {
  orderNumber: '',
  statusIDs: [],
  requestor: '',
  rushOrder: false,
  clientIDs: [],
  reportAddressIDs: [],
  invoiceAddressIDs: [],
  companyName: '',
  ShipCity: '',
  supplyTypes: [],
  shipToFacility: null,
  shipToCompany: [],
  dueDateFrom: null,
  dueDateTo: null,
  templateNo: null,
};

const initialPageState = {
  page: 0,
  pageSize: 20,
  sortColumn: 'CreatedOn',
  sortDirection: SortDirection.Desc,
};
export const OrderSearchsliceName = 'OrderSearch';
const OrderSearchSlice = createSearchPageSlice({
  sliceName: OrderSearchsliceName,
  filterFields,
  initialFilterState,
  initialPageState
});
export const OrderSearchActions = OrderSearchSlice.actions;
export default OrderSearchSlice.reducer;
